import { render, staticRenderFns } from "./SojaSafra2324CarMatopiba.vue?vue&type=template&id=2d199276&lang=pug"
import script from "./SojaSafra2324CarMatopiba.vue?vue&type=script&lang=js"
export * from "./SojaSafra2324CarMatopiba.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports